import storageManager from '@/api/storageManager';
import { setPlanPaymentError } from '@/pages/customer/pawall/subscription/stripe/hooks/useStripePaymentForm';

const decodeStudioStateFromUrl = (encoded) => {
	const binary = atob(decodeURIComponent(encoded));
	const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
	const json = new TextDecoder().decode(bytes);
	return JSON.parse(json);
};

const applyQuizStudioTransfer = ({ studioStateEncoded, fromQuiz }) => {
	if (!fromQuiz) {
		return false;
	}

	let state = null;

	if (studioStateEncoded) {
		try {
			state = decodeStudioStateFromUrl(studioStateEncoded);
		} catch (error) {
			console.error('Failed to decode quiz studio state from URL', error);
		}
	}

	if (!state) {
		state = storageManager.studio.getQuizTransferCookie();
	}

	if (!state) {
		return false;
	}

	storageManager.studio.setState({
		...state,
		step: 'result',
	});
	storageManager.studio.markRestorePending();
	storageManager.studio.clearQuizTransferCookie();
	return true;
};

const appendEmailToPath = (path, email) => {
	if (!email) {
		return path;
	}

	const separator = path.includes('?') ? '&' : '?';
	return `${path}${separator}email=${encodeURIComponent(email)}`;
};

export const buildRedirectDestination = ({
	fromQuiz,
	studioStateEncoded,
	returnPath,
	email,
	isTokenPayment,
}) => {
	if (fromQuiz) {
		applyQuizStudioTransfer({ studioStateEncoded, fromQuiz });
		storageManager.studio.markQuizAutoGeneratePending();
		return appendEmailToPath(`${returnPath}?autoGenerate=1`, email);
	}

	if (!isTokenPayment && returnPath.startsWith('/studio')) {
		storageManager.studio.markRestorePending();
	}

	return returnPath;
};

export const applyPaymentError = ({
	isTokenPayment,
	message,
	returnPath,
	openPlanPaywall,
}) => {
	if (isTokenPayment) {
		storageManager.payment.setError(message);
		return;
	}

	setPlanPaymentError(message);
	openPlanPaywall(returnPath);
};

export const redirectToRetryCheckout = ({
	fromQuiz,
	checkoutReturnUrl,
	navigate,
}) => {
	if (fromQuiz && checkoutReturnUrl) {
		window.location.href = checkoutReturnUrl;
		return;
	}

	navigate('/', { replace: true });
};

export const redirectStripeQuizFailure = (params) => {
	if (!params.isStripeSuccess && params.fromQuiz) {
		if (params.checkoutReturnUrl) {
			window.location.replace(params.checkoutReturnUrl);
			return;
		}

		window.location.replace(buildRedirectDestination(params));
	}
};
